export async function importHmacKey(rawKey) {
    return crypto.subtle.importKey("raw", rawKey, { name: "HMAC", hash: "SHA-256" }, false, ["sign"]);
}
export async function hmacSha256(key, data) {
    const sig = await crypto.subtle.sign("HMAC", key, data);
    return new Uint8Array(sig);
}
//# sourceMappingURL=hmac.js.map